export default __webpack_public_path__ + "static/media/result.772ac6ed.webp";